module.exports = __webpack_public_path__ + "static/media/cusdc.6a061159.svg";